import React from 'react';
import './PrinciplesStrip.css';

const PRINCIPLES = [
  {
    label: 'Anti-Establishment',
    description: 'Independent sources, not corporate narratives',
  },
  {
    label: 'Anti-Partisan',
    description: 'Multiple perspectives, no ideological framing',
  },
  {
    label: 'Anti-Clickbait',
    description: 'Substance over sensational headlines',
  },
];

const PrinciplesStrip = () => {
  return (
    <section className="principles-section" aria-label="Core principles">
      <div className="container">
        <div className="principles-strip">
          {PRINCIPLES.map(({ label, description }) => (
            <div key={label} className="principle-item">
              <span className="principle-label">{label}</span>
              <span className="principle-desc">{description}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PrinciplesStrip;
